import React from "react";
import useMediaQuery from "./useMediaQuery";

export default function PageHeader({ title, subtitle, actions }) {
  const isMobile = useMediaQuery("(max-width: 640px)");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: isMobile ? 12 : 0,
      }}
    >
      <div style={{ marginRight: isMobile ? 0 : 16, marginBottom: 8, minWidth: 0, width: isMobile ? "100%" : "auto" }}>
        <h1 style={{ fontSize: isMobile ? 23 : 28, fontWeight: 800, color: "#fff", margin: 0, letterSpacing: "-0.01em", lineHeight: 1.15 }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ fontSize: isMobile ? 13 : 14, color: "#c3c8cc", margin: "8px 0 0", lineHeight: 1.5 }}>{subtitle}</p>
        )}
      </div>
      {actions && (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", width: isMobile ? "100%" : "auto" }}>
          {React.Children.map(actions, (child, index) =>
            index === 0 ? child : <div style={{ marginLeft: 10 }}>{child}</div>
          )}
        </div>
      )}
    </div>
  );
}
